// removed by extract-text-webpack-plugin
module.exports = {"ColumnParent":"SixtyFourtyBlock__ColumnParent___EyYsU","Media":"SixtyFourtyBlock__Media___KyhMh","MediaImage":"SixtyFourtyBlock__MediaImage___3V6Yo","MediaImageLarge":"SixtyFourtyBlock__MediaImageLarge___zXjBL","MediaImageMedium":"SixtyFourtyBlock__MediaImageMedium___M_sut","MediaImageSmall":"SixtyFourtyBlock__MediaImageSmall___1dBPG","MediaImageInitial":"SixtyFourtyBlock__MediaImageInitial___2-hMo","Content":"SixtyFourtyBlock__Content___uU2cL","ContentCenter":"SixtyFourtyBlock__ContentCenter___odvl4"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/SixtyFourtyBlock/SixtyFourtyBlock.less
// module id = 1207
// module chunks = 0 1